import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  SelectPlanPrice,
  addToPlanAsync,
  fetchPlanPriceAsync,
} from "./PriceSectionSlice";
import { useEffect } from "react";

const user = [{ id: 1, email: "Ab@gmail.com" }];
export default function PriceSection() {
  const dispatch = useDispatch();
  const planPrice = useSelector(SelectPlanPrice);


  useEffect(() => {
    dispatch(fetchPlanPriceAsync());
  }, [dispatch]);
  return (
    <div className="bg-gray-100 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl sm:text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl textM">
            Follow Our Plan and Shape Your Body{" "}
          </h2>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Our experienced trainers will craft a customized workout plan
            tailored to your unique fitness goals and preferences.
          </p>
        </div>

        <div className="mx-auto mt-16 max-w-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex flex-wrap lg:max-w-none">
          {planPrice.map((plan) => (
            <Link to={`/planPrice/${plan.id}`} key={plan.id} className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-sm lg:flex-shrink-0">
              <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:flex-shrink-0">
                <div className="rounded-2xl bg-blue-500 py-10 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-16">
                  <div key={plan.id} className="mx-auto max-w-xs px-8">
                    <p className="text-base font-semibold text-gray-50">
                      {plan.title}
                    </p>
                    <p className="mt-6 flex items-baseline justify-center gap-x-2">
                      <span className="text-5xl font-bold tracking-tight text-white">
                        {plan.price}
                      </span>
                      <span className="text-sm font-semibold leading-6 tracking-wide text-gray-50">
                        RS
                      </span>
                    </p>
                    <div className="flex justify-center items-center text-center">
                      <p className="text-base font-semibold text-gray-50">
                        1-{plan.highlight1}
                      </p>
                    </div>
                    <div className="flex justify-center items-center text-center">
                      <p className="text-base font-semibold text-gray-50">
                        2-{plan.highlight2}
                      </p>{" "}
                    </div>
                    <div className="flex justify-center items-center text-center">
                      <p className="text-base font-semibold text-gray-50">
                        3-{plan.highlight3}
                      </p>{" "}
                    </div>
                   
                  </div>
                  <button
        type="button"
        class="border border-teal-500 bg-teal-500 text-white rounded-md px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-teal-600 focus:outline-none focus:shadow-outline"
      >
        Info
      </button>
                </div>
               
              </div>
            </Link>
          ))}

          {/* this packge*/}
        </div>
      </div>
    </div>
  );
}
